<div class="out">
  <video [src]="rep_stream" autoplay>

  </video>
  <video [src]="caller_stream" autoplay>

  </video>
</div>
